import createDOMPurify from 'dompurify';

// Klient-side sanityzacja podglądu umowy. MUSI odpowiadać serwerowemu
// `sanitizeSectionHtml` (Login/backend/lib/contractHtml.js), żeby PODGLĄD === Test PDF.
// W szczególności styl: tylko text-align / font-size / font-family (te same regexy co serwer)
// — inaczej np. wklejony z Worda kolor/tło pokazałby się w podglądzie, a w PDF zniknął.

const ALLOWED_TAGS = ['p', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'strike',
  'h1', 'h2', 'h3', 'ul', 'ol', 'li', 'span', 'a'];
const ALLOWED_ATTR = ['class', 'data-variable', 'style', 'href', 'target', 'rel', 'start'];

// Dozwolone właściwości CSS = dokładnie te z serwera (SECTION_SANITIZE_OPTIONS.allowedStyles).
const STYLE_ALLOW = {
  'text-align': /^(left|right|center|justify)$/,
  'font-size': /^\d{1,3}(px|pt|em|rem)$/,
  'font-family': /^[\w\s,'"-]+$/,
};

// IZOLOWANA instancja DOMPurify — hook zawężający style rejestrujemy TYLKO na niej,
// więc nie zmieniamy zachowania ewentualnych innych użyć DOMPurify w aplikacji.
const purify = createDOMPurify(window);

// DOMPurify trzyma własny (szerszy) allowlist CSS — zawęź go do naszych 3 właściwości.
purify.addHook('afterSanitizeAttributes', (node) => {
  if (!node.getAttribute || !node.hasAttribute('style')) return;
  const kept = node.getAttribute('style')
    .split(';')
    .map((decl) => decl.trim())
    .filter(Boolean)
    .map((decl) => {
      const idx = decl.indexOf(':');
      if (idx === -1) return null;
      const prop = decl.slice(0, idx).trim().toLowerCase();
      const val = decl.slice(idx + 1).trim();
      const re = STYLE_ALLOW[prop];
      return re && re.test(val) ? `${prop}: ${val}` : null;
    })
    .filter(Boolean);
  if (kept.length) node.setAttribute('style', kept.join('; '));
  else node.removeAttribute('style');
});

export function sanitizeContractHtml(html) {
  return purify.sanitize(String(html == null ? '' : html), { ALLOWED_TAGS, ALLOWED_ATTR });
}
